// ─── MD3 Expressive Menu — Shared Utilities ──────────────────────────────────
import * as React from "react";

/**
 * Recursively flattens React.Fragment nodes and collects valid React elements.
 * Required before using `React.cloneElement`, which cannot be called on Fragment.
 */
export function flattenChildren(nodes: React.ReactNode): React.ReactElement[] {
	return React.Children.toArray(nodes).reduce(
		(acc: React.ReactElement[], child) => {
			if (!React.isValidElement(child)) return acc;
			if (child.type === React.Fragment) {
				return acc.concat(
					flattenChildren(
						(child as React.ReactElement<{ children?: React.ReactNode }>).props
							.children,
					),
				);
			}
			acc.push(child as React.ReactElement);
			return acc;
		},
		[],
	);
}
